<template>
  <div class="mod-show-form">
    <el-form 
      :inline="inline"
      :label-width="labelWidth"
      :label-position="labelPosition"
      class="form"
    >
      <el-form-item 
        v-for="item in formData"
        :key="item.key" 
        :label="item.name"
        :required="item.required"
      >
        <div
          class="input-box"
          :style="{ width: inputWidth }"
        >
          <el-select
            v-if="item.type === 'select'"
            v-model="item.value" 
            :placeholder="item.placeholder"
            :multiple="!!item.multiple"
            :filterable="!!item.filterable"
            class="form-select"
            @change="onChange(item)"
          >
            <el-option
              v-for="option in item.options"
              :key="option.key"
              :label="option.name"
              :value="option.key"
              :disabled="option.disabled"
            />
          </el-select>
          <el-checkbox-group 
            v-else-if="item.type === 'checkbox'"
            v-model="item.value" 
            size="medium"
            :class="{'form-checkbox-group': true, uniline: item.uniline}"
            @change="onChangeByCheckbox(item)"
          >
            <el-checkbox
              v-for="option in item.options"
              :key="option.key"
              :label="option.key"
              :placeholder="item.placeholder"
              :disabled="option.disabled"
              class="form-checkbox"
              border
            >
              <span>{{ option.name }}</span>
              <span 
                v-if="option.desc" 
                class="form-checkbox-desc"
              >
                {{ option.desc }}
              </span>
            </el-checkbox>
          </el-checkbox-group>
          <el-input 
            v-else
            v-model="item.value" 
            :type="item.type"
            resize="none"
            :placeholder="item.placeholder"
            :maxlength="item.maxLength"
            :show-word-limit="!!item.showWordLimit"
            :class="{
              limit: !!item.showWordLimit
            }"
            @keyup.enter.native="onChange(item)"
          />
          <div 
            v-if="item.actions && item.actions.length"
            class="action-box"
          >
            <el-button 
              v-for="btn in item.actions"
              :key="btn.key"
              @click="onAction(item, btn)"
            >
              {{ btn.name }}
            </el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="commitShow">
        <el-button 
          v-if="type==='filter'"
          @click="onSubmit"
        >
          查询
        </el-button>
        <el-button 
          v-else
          type="primary" 
          @click="onSubmit"
        >
          确认
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      default: () => {
        return [];
      },
    },
    inline: {
      default: false,
    },
    type: {
      default: 'form',
    },
    labelWidth: {
      default: '90px',
    },
    labelPosition: {
      default: 'right',
    },
    inputWidth: {
      default: '414px',
    },
    commitShow: {
      default: true,
    },
  },
  methods: {
    getValue() {
      const val = {};
      this.formData.forEach((item) => {
        if (item.value) {
          val[item.key] = item.value;
          if (item.valueFormat) {
            val[item.key] = item.valueFormat(item.value);
          }
        }
      });
      return val;
    },
    onChange(item) {
      this.$emit('change', item);
    },
    onChangeByCheckbox(item) {
      this.$emit('changeCheckbox', item);
    },
    onSubmit() {
      this.$emit('submit', this.getValue());
    },
    onAction() {
      this.$emit('action', ...arguments);
    },
  },
};
</script>

<style lang="scss">
.mod-show-form {
  .el-form-item__label {
    padding-right: 0;
  }
  .el-form-item {
    margin-bottom: 14px;
    .el-select {
      .el-tag__close {
        &.el-icon-close {
          background-color: rgba(0, 0, 0, 0);
        }
      }
    }
    .el-input {
      &.limit {
        .el-input__inner {
          padding-right: 40px;
        }
      }
    }
    .el-textarea {
      &.limit {
        .el-textarea__inner {
          padding-right: 55px;
        }
      }
    }
  }
}
</style>


<style lang="scss" scoped>
.mod-show-form {
  .input-box {
    display: flex;
    width: 414px;
    .form-select {
      width: 100%;
    }
    .action-box {
      margin-left: 10px;
    }
  }
}
</style>
